import React, { useEffect } from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const [initialValues, setInitialValues] = React.useState({
    description: data?.description || '',
  });

  const inputFields = [
    {
      name: 'description',
      label: 'Discussion Point',
      type: 'textarea',
      required: true,
      maxlength: "150",
    },
  ];

  return (
    <CustomAddPage
      pageTitle={data ? 'Update DTP Discussion Point' : 'Add DTP Discussion Point'}
      url={'dtpDiscussionPoints'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="dtpDiscussionPoints"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
